const SHIMMER_CLASS =
  "bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse";

const ShimmerCard = () => (
  <div className="flex items-center gap-2.5 p-1.5 rounded-lg border border-border-gray dark:border-border-gray-dk">
    <div
      className={`shrink-0 w-[40px] h-[40px] rounded-lg ${SHIMMER_CLASS}`}
    />
    <div className="flex flex-col gap-1 min-w-0 flex-1">
      <div className={`h-3.5 w-[120px] ${SHIMMER_CLASS}`} />
      <div className={`h-3 w-[80px] ${SHIMMER_CLASS}`} />
    </div>
  </div>
);

const SectionHeadingShimmer = ({ width }: { width: number }) => (
  <div className="flex items-center gap-1.5">
    <div className={`h-4 ${SHIMMER_CLASS}`} style={{ width }} />
    <div className={`h-4 w-5 rounded ${SHIMMER_CLASS}`} />
  </div>
);

const FileGridViewShimmer = () => {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-3">
        <SectionHeadingShimmer width={60} />
        <div className="grid grid-cols-4 gap-3">
          {Array.from({ length: 4 }).map((_, index) => (
            <ShimmerCard key={`folder-${index}`} />
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <SectionHeadingShimmer width={40} />
        <div className="grid grid-cols-4 gap-3">
          {Array.from({ length: 8 }).map((_, index) => (
            <ShimmerCard key={`file-${index}`} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FileGridViewShimmer;
